const SitesSummaryValidation = (data) => {
  if (data.sites.length > 0) {
    return true;
  } else {
    return false;
  }
};

export default SitesSummaryValidation;
